import { defineComponent as _defineComponent } from 'vue'
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';

import type { Breadcrumb } from '~/types/_next/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'AzBreadcrumbs',
  props: {
    breadcrumbs: null,
    isMobile: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,NuxtLinkCustom, AzIcon }
}

})